import { Injectable } from '@angular/core';

enum FileType{
  png = '.png',
  svg = '.svg',
}
@Injectable({
  providedIn: 'root'
})

export class ButtonService {
  //Represents the subfolder in assets/button-sets
  buttonPath: string;
  buttonClass: string;
  fileType: FileType;

  constructor() {
    const variation = false; // TODO: migrate/remove experimentService.get() test ;

    //For each variation we can make a subfolder of assets and use them and assign a class
    switch(variation) {
      // case 'example':
      //   this.buttonPath = 'example';
      //   this.buttonClass = 'example';
      //   this.fileType = FileType.png;
      //   break;
      default:
        this.buttonPath = 'default';
        this.buttonClass = '';
        this.fileType = FileType.png;
        break;
    }
  }

  get() {
    return {
      buttonPath: this.buttonPath,
      buttonClass: this.buttonClass,
      fileType: this.fileType,
    };
  }
}

